import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">
            实时热度
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            人气榜单
          </h2>
          <p className="mt-2 text-sm text-foreground-500">全网漫画热度排行榜 · 数据每日更新</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-7 gap-4">
          {rankingData.map((item, index) => (
            <div
              key={item.rank}
              className={`bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group ${
                index === 0
                  ? 'lg:col-span-3'
                  : index === 1
                  ? 'lg:col-span-2'
                  : 'lg:col-span-2'
              } ${index >= 2 ? 'lg:col-span-1' : ''}`}
            >
              <div className="flex items-start gap-3">
                <span
                  className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-heading ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="font-heading text-base md:text-lg text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1 flex-wrap">
                    <span className="text-xs text-foreground-500">{item.author}</span>
                    <span className="text-xs px-2 py-0.5 rounded bg-accent-100 text-accent-700 font-medium">
                      {item.genre}
                    </span>
                    <span
                      className={`text-xs font-medium ${
                        item.status === '连载中' ? 'text-primary-600' : 'text-foreground-500'
                      }`}
                    >
                      {item.status}
                    </span>
                  </div>
                  <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                  <div className="mt-3 flex items-center gap-1 text-xs text-accent-600">
                    <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center" />
                    <span className="font-medium">{item.heat}</span>
                    <span className="text-foreground-400">热度</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#index"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer transition-colors"
          >
            查看全部排行榜
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
          </a>
        </div>
      </div>
    </section>
  );
}